import { jsx as _jsx } from "react/jsx-runtime";
import { useDialectSdk, useThread, } from '@dialectlabs/react-sdk';
import CantDecryptError from '../errors/ui/CantDecryptError';
export default function ThreadEncyprionWrapper({ children, otherMemberAddress, }) {
    const { thread } = useThread({
        findParams: {
            otherMembers: otherMemberAddress ? [otherMemberAddress] : [],
        },
    });
    const { info: { supportsEndToEndEncryption }, } = useDialectSdk();
    const cannotDecryptDialect = !supportsEndToEndEncryption && (thread === null || thread === void 0 ? void 0 : thread.encryptionEnabled);
    if (cannotDecryptDialect) {
        return _jsx(CantDecryptError, {});
    }
    return children;
}
//# sourceMappingURL=ThreadEncryptionWrapper.js.map